import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Repository } from '../../../services/repository'
import { ToolDataService } from '../../../services/tooldata.service'
import { DialogComponent, ButtonPropsModel } from '@syncfusion/ej2-angular-popups';
import { AnimationSettingsModel } from '@syncfusion/ej2-splitbuttons';
import { TranslateService } from '@ngx-translate/core';
import { RichTextEditorComponent, TableService, FileManagerService } from '@syncfusion/ej2-angular-richtexteditor';
import { FileManagerSettingsModel, QuickToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { MaskedDateTimeService } from '@syncfusion/ej2-angular-calendars';
import { DienDans } from '../../../routes/menu';


import { loadCldr, L10n } from '@syncfusion/ej2-base';
import {
  ScheduleComponent, MonthService, DayService, WeekService, WorkWeekService,
  AgendaService, MonthAgendaService
} from '@syncfusion/ej2-angular-schedule';

declare let require1: Function;
loadCldr(
  require('../../../../../node_modules/cldr-data/supplemental/numberingSystems.json'),
  require('../../../../../node_modules/cldr-data/main/vi/ca-gregorian.json'),
  require('../../../../../node_modules/cldr-data/main/vi/currencies.json'),
  require('../../../../../node_modules/cldr-data/main/vi/numbers.json'),
  require('../../../../../node_modules/cldr-data/main/vi/timeZoneNames.json')
);

const swal = require('sweetalert');
L10n.load({
  "vi": {
    "schedule": {
      "day": "Ngày",
      "week": "Tuần",
      "workWeek": "Work Week",
      "month": "Month",
      "year": "Year",
      "agenda": "Agenda",
      "weekAgenda": "Week Agenda",
      "workWeekAgenda": "Work Week Agenda",
      "monthAgenda": "Month Agenda",
      "today": "Today",
      "noEvents": "No events",
      "emptyContainer": "There are no events scheduled on this day.",
      "allDay": "All day",
      "start": "Start",
      "end": "End",
      "more": "more",
      "close": "Close",
      "cancel": "Cancel",
      "noTitle": "(No Title)",
      "delete": "Delete",
      "deleteEvent": "This Event",
      "deleteMultipleEvent": "Delete Multiple Events",
      "selectedItems": "Items selected",
      "deleteSeries": "Entire Series",
      "edit": "Edit",
      "editSeries": "Entire Series",
      "editEvent": "This Event",
      "createEvent": "Create",
      "subject": "Subject",
      "addTitle": "Add title",
      "moreDetails": "More Details",
      "save": "Save",
      "editContent": "How would you like to change the appointment in the series?",
      "deleteContent": "Are you sure you want to delete this event?",
      "deleteMultipleContent": "Are you sure you want to delete the selected events?",
      "newEvent": "New Event",
      "title": "Title",
      "location": "Location",
      "description": "Description",
      "timezone": "Timezone",
      "startTimezone": "Start Timezone",
      "endTimezone": "End Timezone",
      "repeat": "Repeat",
      "saveButton": "Save",
      "cancelButton": "Cancel",
      "deleteButton": "Delete",
      "recurrence": "Recurrence",
      "wrongPattern": "The recurrence pattern is not valid.",
      "seriesChangeAlert": "Do you want to cancel the changes made to specific instances of this series and match it to the whole series again?",
      "createError": "The duration of the event must be shorter than how frequently it occurs. Shorten the duration, or change the recurrence pattern in the recurrence event editor.",
      "sameDayAlert": "Two occurrences of the same event cannot occur on the same day.",
      "editRecurrence": "Edit Recurrence",
      "repeats": "Repeats",
      "alert": "Alert",
      "startEndError": "The selected end date occurs before the start date.",
      "invalidDateError": "The entered date value is invalid.",
      "blockAlert": "Events cannot be scheduled within the blocked time range.",
      "ok": "Ok",
      "yes": "Yes",
      "no": "No",
      "occurrence": "Occurrence",
      "series": "Series",
      "previous": "Previous",
      "next": "Next",
      "timelineDay": "Timeline Day",
      "timelineWeek": "Timeline Week",
      "timelineWorkWeek": "Timeline Work Week",
      "timelineMonth": "Timeline Month",
      "timelineYear": "Timeline Year",
      "editFollowingEvent": "Following Events",
      "deleteTitle": "Delete Event",
      "editTitle": "Edit Event",
      "beginFrom": "Begin From",
      "endAt": "End At",
      "expandAllDaySection": "Expand-all-day-section",
      "collapseAllDaySection": "Collapse-all-day-section"
    },
    "recurrenceeditor": {
      "none": "None",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "month": "Month",
      "yearly": "Yearly",
      "never": "Never",
      "until": "Until",
      "count": "Count",
      "first": "First",
      "second": "Second",
      "third": "Third",
      "fourth": "Fourth",
      "last": "Last",
      "repeat": "Repeat",
      "repeatEvery": "Repeat every",
      "on": "Repeat On",
      "end": "End",
      "onDay": "Day",
      "days": "Day(s)",
      "weeks": "Week(s)",
      "months": "Month(s)",
      "years": "Year(s)",
      "every": "every",
      "summaryTimes": "time(s)",
      "summaryOn": "on",
      "summaryUntil": "until",
      "summaryRepeat": "Repeats",
      "summaryDay": "day(s)",
      "summaryWeek": "week(s)",
      "summaryMonth": "month(s)",
      "summaryYear": "year(s)",
      "monthWeek": "Month Week",
      "monthPosition": "Month Position",
      "monthExpander": "Month Expander",
      "yearExpander": "Year Expander",
      "repeatInterval": "Repeat Interval"
    }
  }
});



@Component({
  selector: 'app-daotao-baivietview', 
  templateUrl: './baivietview.component.html',
  styleUrls: ['./baivietview.component.scss'],
  providers: [Repository, MaskedDateTimeService,
    DayService, WeekService, WorkWeekService, MonthService, AgendaService, MonthAgendaService
  ]
})

export class baivietviewComponent implements OnInit {

  @Output() savect: EventEmitter<any> = new EventEmitter();

  @ViewChild('Dialog')
  public Dialog: DialogComponent;


  public width: string = '50%';
  public animationSettings: AnimationSettingsModel = { effect: 'None' };
  public target: string = '.control-section';

  data: any;  
  donviid: string = null;
  username: string = null;
  lopid: any = null;
  chudeid: any = null;
  id: any = null;
  currentUser: any;

  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;

  baivietSelect: any = {
    TieuDe: null, Id: null, NoiDung: null, DonViId: null, ChuDeId: null, CreatedBy: null,
    KeyWord: null, CoAnh: null, NhanSuId: null, LuotBinhLuan: null, Lop: null,
    LopId: null, LuotLike: null, LuotDislike: null, TuKhoas: null, TraLois: null
  }
  postSelect: any = {
    TieuDe: null, Id: null, NoiDung: null, DonViId: null, ChuDeId: null, KeyWord: null, ModifiedBy: null, CreatedBy: null,
    LopId: null, LuotLike: null, LuotDislike: null, TuKhoas: null, TraLois: null, ParentId: null
  }

  constructor(private route: ActivatedRoute,private router: Router,public repo: Repository, private translateService: TranslateService, private tooldata: ToolDataService) {
   
  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit() {
    //this.id = this.route.snapshot.params["id"];
    //this.lopid = this.route.snapshot.params["cid"];
    this.currentUser = localStorage.getItem('currentUser');
    let tttdata;
   
   
  }
  loadInit(id, lopid,chudeid, username,cr) {
    //------------------quyen--------------------
    this.currentUser = cr;
    if (this.currentUser) {
      this.donviid = this.currentUser.id_don_vi;

      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === DienDans.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }

    }

    //--------------------------------------------
    this.id = id;
    this.lopid = lopid;
    this.chudeid = chudeid;
    this.username = username;
    this.loadData();

    const posviewid: HTMLElement = document.querySelector('#createpostholder');
    posviewid.classList.add("hidediv");
  }
  loadData() {
    this.repo.postRequest("api/diendan/getbaipost/", { id: this.id, status: 0 })
      .subscribe(response => {
        if (response.BaiViet !== null && response.BaiViet !== undefined && response.BaiViet.length > 0) {
          this.baivietSelect.Id = response.BaiViet[0].Id;
          this.baivietSelect.TieuDe = response.BaiViet[0].TieuDe;
          this.baivietSelect.CreatedBy = response.BaiViet[0].CreatedBy;
          this.baivietSelect.Created = response.BaiViet[0].Created;
          this.baivietSelect.NoiDung = response.BaiViet[0].NoiDung;
          this.baivietSelect.CoAnh = response.BaiViet[0].CoAnh;
          this.baivietSelect.LopId = response.BaiViet[0].LopId;
          this.baivietSelect.Lop = response.BaiViet[0].Lop;
          this.baivietSelect.ChuDeId = response.BaiViet[0].ChuDeId;
          this.baivietSelect.NhanSuId = response.BaiViet[0].NhanSuId;
          this.baivietSelect.LuotLike = response.BaiViet[0].LuotLike;
          this.baivietSelect.LuotDislike = response.BaiViet[0].LuotDislike;
          this.baivietSelect.DaLike = response.BaiViet[0].DaLike;
          this.baivietSelect.DaDislike = response.BaiViet[0].DaDislike;
          this.baivietSelect.LuotBinhLuan = response.BaiViet[0].LuotBinhLuan;
        }

        this.baivietSelect.TuKhoas = response.TuKhoas;
        this.baivietSelect.TraLois = response.TraLois;
        console.log(this.baivietSelect);
      });
  }

  
  public savebaiviet() {
    console.log(this.baivietSelect);
    if (this.baivietSelect.TieuDe === null || this.baivietSelect.TieuDe === '') {
      swal('Cảnh báo!', "Bạn chưa nhập tiêu đề bài viết!!!", 'warning');
      return;
    }    
    this.baivietSelect.DonViId = this.donviid;
    this.baivietSelect.LopId = this.lopid;
    this.baivietSelect.ChuDeId = this.chudeid;
    this.repo.postRequest("api/diendan/addorupdate", this.baivietSelect)
      .subscribe(response => {

        if (response.Status === "OK")
          this.router.navigate(['/daotaos/vaolop', this.baivietSelect.ChuDeId]);
        else
          swal('Cảnh báo!', response.Status, 'warning');
      });
  }
  //---------------------chen post---------------
  deleterow(row: any, loai: number) {
    console.log(this.username);
    swal({
      title: 'Bạn muốn xóa bài viết này phải không?',
      text: 'Dữ liệu xóa sẽ không thể phục hồi lại!!!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.postRequest('api/diendan/postdelete/', { Id: row.Id, PhanHeId: null, UserName: this.username }).subscribe(
            data => {
              if (data == "OK") //Success
              {
                swal('Deleted!', 'Dữ liệu đã được xóa!.', 'success');
                if (loai == 1) {
                  this.savect.emit(this.baivietSelect);
                }
                else
                  this.loadData();
              }
              else {
                // this.msg = data;
                swal('Cảnh báo!', data, 'warning');
              }


            },
            error => {
              //this.msg = error;
            }
          );
        }
      });


  }

  public cancelClick = (): void => {
    this.rteObj.refresh();
    this.rteObj.value = '';
  }
  public submitClick = (): void => {

    console.log(this.baivietSelect);
    if (this.postSelect.NoiDung === null || this.postSelect.NoiDung === '') {
      swal('Cảnh báo!', "Bạn chưa nhập tiêu đề bài viết!!!", 'warning');
      return;
    }
    this.postSelect.DonViId = this.donviid;
    this.postSelect.ChuDeId = this.lopid;
    this.postSelect.ParentId = this.id;
    this.postSelect.ModifiedBy = this.currentUser.user_name;
    this.postSelect.CreatedBy = this.currentUser.user_name;
    this.repo.postRequest("api/diendan/addorupdate", this.postSelect)
      .subscribe(response => {

        if (response.Status === "OK") {
          this.loadData();
          this.rteObj.refresh();
          this.rteObj.value = '';
        }
          
        else
          swal('Cảnh báo!', response.Status, 'warning');
      });

  
  }
  likedispost(data: any, loai: number) {
    if (loai == 1 && data.DaLike == 0) {
      data.LuotLike = data.LuotLike + 1;
      data.DaLike = 1;
    }
      
    if (loai == 0 && data.DaDislike == 0) {
      data.LuotDislike = data.LuotDislike + 1;
      data.DaDislike = 1;
    }
    if (data.DaLike == 0 || data.DaDislike == 0) {
      this.repo.postRequest("api/diendan/addorupdatelike", { DienDanId: data.Id, UserName: this.currentUser.user_name, Loai: loai })
        .subscribe(response => {

          if (response.Status === "OK") {
            this.loadData();
            this.rteObj.refresh();
            this.rteObj.value = '';
          }

          else
            swal('Cảnh báo!', response.Status, 'warning');
        });
    }
   
  }
  hidereply: boolean = true;
  reply(data:any,loai: number) {    
    const posviewid: HTMLElement = document.querySelector('#createpostholder');
    posviewid.classList.remove("hidediv")

    if (loai == 2) {
      this.postSelect.NoiDung = "<blockquote>" + data.NoiDung + "<h4>—" + data.CreatedBy + "—</h4></blockquote><p><br></p>";
    }
  }
  /*--------------Editor------------------------*/
  @ViewChild('toolsRTE')
  public rteObj: RichTextEditorComponent;

  private hostUrl: string = '/';

  public tools: ToolbarModule = {
    type: 'MultiRow',
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', 'SuperScript', 'SubScript', '|',
      'Formats', 'Alignments', 'NumberFormatList', 'BulletFormatList',
      'Outdent', 'Indent', '|',
      'CreateTable', 'CreateLink', 'Image', 'FileManager', '|', 'ClearFormat', 'Print',
      'SourceCode', 'FullScreen', '|', 'Undo', 'Redo']
  };
  public insertImageSettings: Object = {
    saveFormat : 'Base64',
    //saveUrl: 'https://ej2.syncfusion.com/services/api/uploadbox/Save',
    //removeUrl: 'https://ej2.syncfusion.com/services/api/uploadbox/Remove'
  };
  public fileManagerSettings: FileManagerSettingsModel = {
    enable: true,
    path: '',
    ajaxSettings: {
      url: this.hostUrl + 'FileManager/FileOperations',
      getImageUrl: this.hostUrl + 'FileManager/GetImage',
      uploadUrl: this.hostUrl + 'FileManager/Upload',
      downloadUrl: this.hostUrl + 'FileManager/Download'
    }
  };

  public actionCompleteHandler(e: any): void {
    console.log("actiondsdsd");
    console.log(e);
    if (e.targetItem && (e.targetItem === 'SourceCode' || e.targetItem === 'Preview')) {
     
    } else {
      setTimeout(() => { this.rteObj.toolbarModule.refreshToolbarOverflow(); }, 1000);
    }
  }
}
